import { render, staticRenderFns } from "./copy_handle.vue?vue&type=template&id=ff46ee90&scoped=true"
import script from "./copy_handle.vue?vue&type=script&lang=js"
export * from "./copy_handle.vue?vue&type=script&lang=js"
import style0 from "./copy_handle.vue?vue&type=style&index=0&id=ff46ee90&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff46ee90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff46ee90')) {
      api.createRecord('ff46ee90', component.options)
    } else {
      api.reload('ff46ee90', component.options)
    }
    module.hot.accept("./copy_handle.vue?vue&type=template&id=ff46ee90&scoped=true", function () {
      api.rerender('ff46ee90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/process/components/copy_handle/copy_handle.vue"
export default component.exports